import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridState) {
  return postRequest(
    `get/employees`,
    gridState,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `get/employee/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
    return putRequest(
    `employees/activation/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return formDataPostRequest(
    `employees`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data, id) {
    return formDataPostRequest(
    `employees/${id}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteEmployeePermanentById(id) {
    return deleteRequest(
    `delete/employee/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function dashboardStats() {
  return getRequest(
    `get/dashboard/stats`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function employeeCheckIn(data) {
    return postRequest(
    `attendance/check-in`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function employeeCheckOut(data) {
    return postRequest(
    `attendance/check-out`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllEmployeeAttendanceById(id) {
  return postRequest(
    `get/attendance/${id}`,
    id,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateSession(data) {
    return postRequest(
    `attendance/update-session`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllAttendances() {
  return postRequest(
    `get/attendance`,
    null,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addSession(data) {
    return postRequest(
    `attendance/add-session`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function duplicateAttendance(data) {
  return postRequest(
    `attendance/duplicate`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const employeeService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
  deleteEmployeePermanentById,
  dashboardStats,
  employeeCheckIn,
  employeeCheckOut,
  getAllEmployeeAttendanceById,
  getAllAttendances,
  updateSession,
  addSession,
  duplicateAttendance
};
